import { render, staticRenderFns } from "./avatars.vue?vue&type=template&id=e05acd5c&scoped=true&"
import script from "./avatars.vue?vue&type=script&lang=js&"
export * from "./avatars.vue?vue&type=script&lang=js&"
import style0 from "./avatars.vue?vue&type=style&index=0&id=e05acd5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05acd5c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/builds/master/frontend/frontend-universe/components/avatar.vue').default})
